<template>
  <div>
    <div id="audio-container"></div>
  </div>
</template>

<script>
export default {
  name: 'AudioPlayer',
  props: {
    audioUrl: String,
  },
  computed: {},
  watch: {
    audioUrl: function(newVal) {
      if (newVal) {
        this.replaceAudio(this.audioUrl)
      }
    },
  },
  methods: {
    replaceAudio: function(src) {
      const newAudio = document.createElement('audio')
      newAudio.controls = true
      newAudio.src = src

      const parentNode = document.getElementById('audio-container')
      parentNode.innerHTML = ''
      parentNode.appendChild(newAudio)
    },
  },
  mounted: function() {
    if (this.audioUrl){
      this.replaceAudio(this.audioUrl)
    }    
  },
}
</script>

<style>
audio {
  width: 100%;
  padding-top: 12px;
}

#audio-container {
  margin-bottom: 1em;
}
</style>
